export default __webpack_public_path__ + "static/media/water2.6037dfc5.jpeg";